import {Injectable} from '@angular/core';
import {CommonService} from './common.service';
import {Tool} from '../model/tool';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ToolService extends CommonService<Tool> {
  constructor(http: HttpClient) {
    super(http, '/tools');
  }
}
